import './Contactlist.css'
import { useUserAuth } from "../Login/UserAuthContext";
import { Avatar, Button } from 'antd';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { auth ,db} from '../Login/Config';
import {collection,query,where,onSnapshot, orderBy} from 'firebase/firestore'
export default function Contactlist(){
    const {user,logOut} = useUserAuth()
    const [users,setUsers] = useState([])
    const [error,setError] = useState('')
    const [chat,setChat] = useState()
    
    let navigate = useNavigate()
    useEffect(()=>{
        const userRef = collection(db,'users')
        const q = query(userRef, where('uid','not-in',[auth.currentUser.uid]))
        const unsub = onSnapshot(q,(querySnapshot)=>{
            let users = []
            querySnapshot.forEach(doc=>{
                users.push(doc.data())
            })
            setUsers(users)
        })
        return ()=>unsub()
    },[])
    const gotoChatroom = (id)=>{
        navigate(`/chatroom${id}?idRoom=${id}`)
    }
    const handleLogOut = async(e) =>{
        e.preventDefault()
        setError('')
        try{
            await logOut();
            navigate('/');
        } 
        catch(err){
            setError(err.message)
        }
    }
    return(
        <div style={{width:'100%',height:'100vh',display:'flex',justifyContent:'center',backgroundColor:'#ccc'}}>
            <div className='contactlist'>
                <div className='contactlist-header'>
                    <Avatar src={user ? user.photoURL : ''}></Avatar>
                    <h2 style={{color:'white',margin:'0'}}><i className="fa-solid fa-comments"></i> MeChat</h2>
                    <Button className='logout-btn' onClick={handleLogOut}>Đăng Xuất</Button>
                </div>
                <div className='contactlist-container' >
                    {users.map((user,index)=>(
                        <div className='contactlist-item' key={index} onClick={()=>{gotoChatroom(user.uid)}}>
                            <Avatar src={user.avt} style={{marginRight:'1vw'}}></Avatar>
                            <div style={{display:'flex',flexDirection:'column',justifyContent:'space-evenly'}}>
                                <h2 style={{margin:'0',color:'rgb(24, 144, 255)',fontSize:'2.5vmin'}} className='contactlist-item-name'>{user.name}</h2>
                                {user.isOnline ? <p style={{margin:'0',color:'rgb(24, 144, 255)',fontSize:'2vmin'}} className='contactlist-item-isOnline'>Đang hoạt động</p> : <p style={{margin:'0',color:'#ccc',fontSize:'2vmin'}} className='contactlist-item-isOnline'>Offline</p> }
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}